import moment from 'moment';
import {
  MY_FILTER,
  // 时间筛选器
  RANGE_TIME as FILTER_RANGE_TIME,
  // 发布时间筛选器
  RELEASE_TIME as FILTER_RELEASE_TIME,

  // 单数据源筛选器
  SINGLE_SOURCE_SELECT as FILTER_SINGLE_SOURCE_SELECT,
  SINGLE_SOURCE_SELECT_EXTEND_TYPE,

  // 组合国家筛选器
  COMPOSED_COUNTRY_SELECT as FILTER_COMPOSED_COUNTRY_SELECT,
  COMPOSED_COUNTRY_SELECT_EXTEND_TYPE,

  // 品类筛选器
  GENRETOR as FILTER_GENRE_SELECT,

  // Product Model筛选器
  SENSOR_TOWER_TAG_PRODUCT_MODEL,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { MOBILE_SOURCES } from '@/pages/intelligence/_config/storeRank/config';

const isValidDate = (date: moment.Moment) =>
  // 选择范围在今天之前
  date.isSameOrBefore(moment(), 'day');

// 筛选器默认配置
export const FILTER_DEFAULT_LIST_MAP = {
  MY_FILTER: {
    savePopupVisble: 0,
    key: MY_FILTER,
    value: '',
  },
  FILTER_RANGE_TIME: {
    savePopupVisble: 1,
    key: FILTER_RANGE_TIME,
    type: FILTER_RANGE_TIME,
    visible: 1,
    disabled: false,
    disabledDate: isValidDate,
    calendarType: 'date',
    autoRange: {
      timeType: 'date',
      length: 0,
    },
    showSelectType: false,
    showShortcut: false,
  },
  FILTER_RELEASE_TIME: {
    savePopupVisble: 1,
    key: FILTER_RELEASE_TIME,
    type: FILTER_RANGE_TIME,
    visible: 1,
    disabled: false,
    disabledDate: { date: isValidDate },
    calendarType: 'date',
    showSelectType: false,
    showShortcut: false,
  },
  FILTER_SINGLE_SOURCE_SELECT: {
    savePopupVisble: 1,
    key: FILTER_SINGLE_SOURCE_SELECT,
    type: FILTER_SINGLE_SOURCE_SELECT,
    extendFilterType: SINGLE_SOURCE_SELECT_EXTEND_TYPE.common,
    visible: 1,
    disabled: false,
    entityType: 'mobile',
    sources: MOBILE_SOURCES,
    isNotSaveByDefault: true, // 保存弹窗默认不勾选
  },
  FILTER_COMPOSED_COUNTRY_SELECT: {
    savePopupVisble: 1,
    key: FILTER_COMPOSED_COUNTRY_SELECT,
    type: FILTER_COMPOSED_COUNTRY_SELECT,
    className: 'dbi-mobile-store-rank_composed-country-select',
    extendFilterType: COMPOSED_COUNTRY_SELECT_EXTEND_TYPE.common,
    visible: 1,
    disabled: false,
    isShowTypeSelect: true,
    useRegionCascaderForSingle: true,
    useRegionSelectorForMultiple: true,
    isAll: false,
    options: [],
    title: 'dbi_region',
  },
  FILTER_GENRE_SELECT: {
    savePopupVisble: 1,
    key: FILTER_GENRE_SELECT,
  },
  FILTER_SENSOR_TOWER_TAG_PRODUCT_MODEL: {
    savePopupVisble: 1,
    key: SENSOR_TOWER_TAG_PRODUCT_MODEL,
    title: 'dbi_detail_product_model',
    default: {
      value: [],
    },
  },
};

// 筛选器默认值
export const FILTER_DEFAULT_VALUE = {
  [MY_FILTER]: {
    value: '',
  },
  [FILTER_RANGE_TIME]: {
    type: 'date',
    value: [moment(), moment()],
  },
  [FILTER_RELEASE_TIME]: {
    value: ['', ''],
  },
  [FILTER_SINGLE_SOURCE_SELECT]: {
    value: MOBILE_SOURCES[0],
  },
  [FILTER_COMPOSED_COUNTRY_SELECT]: {
    value: {
      type: 'multiple',
      countries: [],
    },
  },
  [FILTER_GENRE_SELECT]: {
    source: 'sensortower',
    mainGenres: [],
    subGenres: [],
    level3Genres: [],
    level4Genres: [],
  },
  [SENSOR_TOWER_TAG_PRODUCT_MODEL]: {
    value: [],
  },
};

// 筛选器默认配置
export const FILTER_DEFAULT_INPUT_LIST = [
  FILTER_DEFAULT_LIST_MAP.MY_FILTER,
  FILTER_DEFAULT_LIST_MAP.FILTER_RANGE_TIME,
  FILTER_DEFAULT_LIST_MAP.FILTER_SINGLE_SOURCE_SELECT,
  FILTER_DEFAULT_LIST_MAP.FILTER_COMPOSED_COUNTRY_SELECT,
  FILTER_DEFAULT_LIST_MAP.FILTER_GENRE_SELECT,
  FILTER_DEFAULT_LIST_MAP.FILTER_RELEASE_TIME,
  FILTER_DEFAULT_LIST_MAP.FILTER_SENSOR_TOWER_TAG_PRODUCT_MODEL,
];
